import { render, staticRenderFns } from "./premiTable.vue?vue&type=template&id=e76265c0&"
import script from "./premiTable.vue?vue&type=script&lang=ts&"
export * from "./premiTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports